<div class="flex flex-col">
  <div class="self-center">
    <div>
      <span>{{ 'authentication-setup-page.description' | translate }}</span>
    </div>
    <div class="mb-6 mt-4">
      <a
        href="{{ 'authentication-setup-page.need-help.url' | translate }}"
        target="_blank"
        class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130">
        {{ 'authentication-setup-page.need-help' | translate }}
      </a>
    </div>
  </div>
  @if (token.accessToken) {
    <pay-login-setup-two-factor-auth-chooser [mfaBearer]="token.accessToken" />
  }
  <div class="self-center pt-5">
    <span class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="returnToLogin()">
      {{ 'authentication-setup-page.go-back' | translate }}
    </span>
  </div>
</div>
